export default "__VITE_ASSET__BC$gqK6o__"